<template>
  <div>
    <v-row>
      <v-col class="min-width-7" cols="7">
        <FormConjugation ref="form" />
      </v-col>
      <v-col class="min-width-4 max-width-4 ml-10 p-0 pb-2" cols="4">
        <div class="template-show pa-3">
          <TemplateConjugation :no="this.$route.query.no" />
        </div>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-btn color="primary" class="ml-10" @click="checkValidate">{{
        $t("REGISTER")
      }}</v-btn>
      <Dialog v-model="dialogConfirmCreate" :title="$t('COMFIRMATION')">
        <template v-slot:content>登録します。よろしいですか。</template>
        <template v-slot:actions>
          <v-btn color @click="dialogConfirmCreate = false" small>{{
            $t("CANCEL")
          }}</v-btn>
          <v-btn
            :disabled="loading"
            color="primary"
            small
            :loading="loading"
            @click="handleCreateQuestion"
            >{{ $t("OK") }}</v-btn
          >
        </template>
      </Dialog>

      <v-btn color class="ml-10" @click="$router.go(-1)">{{
        $t("BACK")
      }}</v-btn>
    </v-row>
  </div>
</template>
<script>
import FormConjugation from "@/views/drill/Exercises/FormConjugation.vue";
import TemplateConjugation from "@/views/drill/Exercises/TemplateConjugation.vue";
import uploadFile from "@/utils/uploadFile";
import { createQuestion } from "@/api/Pratice.api";
import Dialog from "@/components/Dialog/Dialog";
export default {
  store: ["formGeneral"],
  components: {
    FormConjugation,
    TemplateConjugation,
    Dialog,
  },
  data() {
    return {
      loading: false,
      dialogConfirmCreate: false,
    };
  },
  methods: {
    async handleCreateQuestion() {
      this.loading = true;
      console.log("a----");
      const {
        query,
        params: { drillId },
      } = this.$route;
      let params = await this.$refs.form.getParams();
      if (params) {
        params = await this.checkFile(params);
        await createQuestion(params)
          .then(async () => {
            this.dialogConfirmCreate = false;
            this.$router.push({
              name: "List Exercises Of Drill",
              query,
              params: { drillId },
            });
          })
          .catch((error) => {
            this.loading = false;
            this.$toast.error(error);
          });
      } else {
        this.loading = false;
        this.dialogConfirmCreate = false;
      }
    },
    async checkValidate() {
      let params = await this.$refs.form.getParams();
      if (params) {
        console.log("params: ", this.dialogConfirmCreate);
        this.dialogConfirmCreate = true;
      }
    },
    async checkFile(params) {
      if (params.audio && params.audio.file) {
        await uploadFile(params.audio.file, "audio").then((e) => {
          params.audio = e;
        });
      }
      if (params.image && params.image.file) {
        await uploadFile(params.image.file, "image").then((e) => {
          params.image = e;
        });
      }
      if (
        params.sub_question.question1.audio &&
        params.sub_question.question1.audio.file
      ) {
        await uploadFile(
          params.sub_question.question1.audio.file,
          "audio"
        ).then((e) => {
          params.sub_question.question1.audio = e;
        });
      }
      if (
        params.sub_question.question2.audio &&
        params.sub_question.question2.audio.file
      ) {
        console.log("question2: ", params.sub_question.question2);
        await uploadFile(
          params.sub_question.question2.audio.file,
          "audio"
        ).then((e) => {
          params.sub_question.question2.audio = e;
        });
      }
      return params;
    },
  },
  beforeDestroy() {
    this.formGeneral = {
      leadSentence: "",
      name1: "",
      name2: "",
      isAnsewr: 1,
      verb: "",
      kanji: "",
      audio: null,
      image: null,
      script: "",
      sub_question: {
        question1: {
          answers: [
            {
              id: 1,
              name: "回答1",
              value: "",
            },
            {
              id: 2,
              name: "回答2",
              value: "",
            },
            {
              id: 3,
              name: "回答3",
              value: "",
            },
            {
              id: 4,
              name: "回答4",
              value: "",
            },
          ],
          script: "",
          audio: null,
          isAnsewr: 1,
        },
        question2: {
          answers: [
            {
              id: 1,
              name: "回答1",
              value: "",
            },
            {
              id: 2,
              name: "回答2",
              value: "",
            },
            {
              id: 3,
              name: "回答3",
              value: "",
            },
            {
              id: 4,
              name: "回答4",
              value: "",
            },
          ],
          script: "",
          audio: null,
          isAnsewr: 1,
        },
      },
      answers: [
        {
          id: 1,
          name: "回答1",
          value: "",
        },
        {
          id: 2,
          name: "回答2",
          value: "",
        },
        {
          id: 3,
          name: "回答3",
          value: "",
        },
        {
          id: 4,
          name: "回答4",
          value: "",
        },
      ],
      answersConjugation: [
        {
          id: 1,
          value: "",
        },
        {
          id: 2,
          value: "",
        },
        {
          id: 3,
          value: "",
        },
        {
          id: 4,
          value: "",
        },
      ],
      wrongAnswersConjugation: [
        {
          id: 1,
          value: "",
        },
        {
          id: 2,
          value: "",
        },
        {
          id: 3,
          value: "",
        },
        {
          id: 4,
          value: "",
        },
      ],
    };
  },
};
</script>
<style scoped>
.template-show {
  border: 1px solid #ccc;
}
</style>